/**
 * Las imágenes originales pesan más de lo que se muestra en pantalla. Este
 * proxy (wsrv.nl, gratuito y con CDN) las redimensiona al ancho exacto, las
 * entrega en WebP comprimido y con caché de larga duración.
 */
const PROXY = 'https://wsrv.nl/'

export function optimizedImage(url: string, width: number, quality = 72): string {
  const params = new URLSearchParams({
    url,
    w: String(width),
    output: 'webp',
    q: String(quality),
  })
  return `${PROXY}?${params.toString()}`
}

export function optimizedSrcSet(
  url: string,
  widths: number[],
  quality?: number,
): string {
  return widths
    .map((width) => `${optimizedImage(url, width, quality)} ${width}w`)
    .join(', ')
}

/** Mockup del hero: anchos disponibles y ancho real en cada breakpoint. */
export const HERO_WIDTHS = [480, 720, 960, 1240]
export const HERO_SIZES =
  '(min-width: 1024px) 420px, (min-width: 640px) 360px, 270px'

/** Foto dei bonus: piena larghezza su mobile, colonna di 240/300px da sm/lg. */
export const BONUS_WIDTHS = [360, 480, 720, 960]
export const BONUS_SIZES =
  '(min-width: 1024px) 300px, (min-width: 640px) 240px, calc(100vw - 48px)'
